import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private handling401 = false;

  constructor(private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let request = req;

    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');

      const isApiRequest =
        req.url.startsWith('https://backend.sbcat.org.br') ||
        req.url.startsWith('/api');


      if (token && isApiRequest) {
        const cloned = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          }
        });
        // debug: log URL and final headers
        try {
          const headersObj: any = {};
          cloned.headers.keys().forEach(k => headersObj[k] = cloned.headers.get(k));
        } catch (e) {
          console.log('[AuthInterceptor] Request with auth ->', cloned.url);
        }
        request = cloned;
      } else {
        // sem token: log a warning para depuração
        // log também valor atual do storage para depuração
        try {
          const headersObj: any = {};
          req.headers.keys().forEach(k => headersObj[k] = req.headers.get(k));
        } catch (e) {
          console.log('[AuthInterceptor] Request without token ->', req.url);
        }
      }
    } catch (e) {
      // ignore
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const isUnauthorized = error && error.status === 401;
        const isLoginRequest = request.url && request.url.includes('/login');

        if (isUnauthorized && !isLoginRequest && !this.handling401) {
          this.handling401 = true;
          sessionStorage.removeItem('token');
          localStorage.removeItem('token');
          sessionStorage.removeItem('usuario');

          window.alert('Sua sessão expirou. Faça login novamente.');
          this.router.navigate(['/login']);
        }

        return throwError(error);
      })
    );
  }
}
